import React, { useCallback, useMemo, useState } from 'react';
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { Checkbox } from 'baseui/checkbox';
import { Input } from 'baseui/input';
import { FormControl } from 'baseui/form-control';
import { Select } from 'baseui/select';
import { validationTypes, MAX_FILE_SIZE_UNITS, MAX_ALLOWED_FILE_SIZE, type QuestionType, type Validation } from '../../../../reducers';
import { ValidationMessages } from '../../../../reducers/selectors';
import { isEmpty, getSizeInBytes, getSizeInUnit, toFixedString } from '../../../../utils/answer';
import { ValidationRow } from '../styled-components';
import { getValidationByType } from '../utils';
import { type ValidationReducerActionTypeT } from '../reducers';
type PropsT = {
  question: QuestionType;
  validationState: Array<Validation | undefined | null>;
  dispatch: (a: {
    kind?: string;
    type: ValidationReducerActionTypeT;
    value?: string;
  }) => void;
};
export default function MaxFileSizeValidation({
  question,
  validationState,
  dispatch
}: PropsT) {
  const maxFileSizeValidation = getValidationByType(validationState, validationTypes.MAX_FILE_SIZE);
  const {
    size,
    unit
  } = useMemo(() => {
    const arr = (maxFileSizeValidation?.value || '').split(' ');
    return {
      size: arr[0] ?? 0,
      unit: arr[1] ?? 'MB'
    };
  }, [maxFileSizeValidation?.value]);
  const [sizeError, setSizeError] = useState<string | undefined | null>();
  const validate = useCallback((size, unit) => {
    let value = `${size} ${unit}`;
    if (getSizeInBytes(value) > MAX_ALLOWED_FILE_SIZE) {
      value = getSizeInUnit(MAX_ALLOWED_FILE_SIZE, unit);
      setSizeError(ValidationMessages.getMaxAllowedFileSize(value));
    } else {
      // @ts-expect-error todo(ts-migration) TS2554 Expected 1 arguments, but got 0.
      setSizeError();
    }
    return value;
  }, [setSizeError]);
  return <ValidationRow>
      <Checkbox checked={validationState.some(validation => validation?.type === validationTypes.MAX_FILE_SIZE)} onChange={e => {
      if (e.target.checked) {
        dispatch({
          type: 'ADD_VALIDATION',
          value: validationTypes.MAX_FILE_SIZE
        });
      } else {
        dispatch({
          type: 'REMOVE_VALIDATION',
          value: validationTypes.MAX_FILE_SIZE
        });
      }
    }}>
        Max File Size
      </Checkbox>{' '}
      {!isEmpty(maxFileSizeValidation) && <FlexGrid flexGridColumnCount={2}>
          <FlexGridItem>
            <FormControl error={sizeError}>
              <Input type="number" required placeholder="Enter maximum allowed file size here" value={size} min={1} onChange={e => {
            dispatch({
              type: 'ADD_VALUE',
              kind: validationTypes.MAX_FILE_SIZE,
              value: validate(toFixedString(e.target.value), unit)
            });
          }} />
            </FormControl>
          </FlexGridItem>
          <FlexGridItem maxWidth="100px">
            <Select clearable={false} required options={MAX_FILE_SIZE_UNITS} value={[{
          id: unit,
          label: unit
        }]} onChange={({
          value
        }) => {
          dispatch({
            type: 'ADD_VALUE',
            kind: validationTypes.MAX_FILE_SIZE,
            value: validate(size, String(value[0].id) || 'MB')
          });
        }} />
          </FlexGridItem>
        </FlexGrid>}
    </ValidationRow>;
}